/** All available route paths in the app. */
export enum RoutePath {
	List = "list",
	Login = "login",
	Map = "map",
	Roadwork = "roadwork",
}

/** The default route all wildcards should redirect to. */
export const DEFAULT_REDIRECT_ROUTE = `/${RoutePath.List}`;

/** The query param name used in the roadworks route to identify a roadwork id. */
export const ROADWORK_ID_ROUTE_PARAM_NAME = "roadworkId";
export const ASSET_ID_ROUTE_PARAM_NAME = "scannedAssetId";
